module.exports = __webpack_public_path__ + "img/Truvito_bg_dark.78de6603.png";